export default function SVGPhoneSmall(props: any) {
    return (
        <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M28.0977 4.6875C24.9726 1.56248 21.2018 0 16.7852 0C12.3685 0 8.59767 1.56248 5.47266 4.6875C2.34764 7.81251 0.785156 11.5833 0.785156 16C0.785156 20.4167 2.34764 24.1875 5.47266 27.3125C8.59767 30.4375 12.3685 32 16.7852 32C21.2018 32 24.9726 30.4375 28.0977 27.3125C31.2227 24.1875 32.7852 20.4167 32.7852 16C32.7852 11.5833 31.2227 7.81251 28.0977 4.6875Z"
                fill="#919191"
            />
            <path
                d="M20.4253 8C20.0698 8 19.7422 8.1928 19.5696 8.50363L18.3726 10.6599C18.2158 10.9423 18.2085 11.2838 18.3529 11.5726L19.5061 13.8791C19.5061 13.8791 19.1719 15.5973 17.7733 16.9959C16.3746 18.3946 14.6622 18.723 14.6622 18.723L12.3561 17.57C12.067 17.4254 11.7253 17.4329 11.4429 17.5899L9.28046 18.7922C8.96994 18.9649 8.77734 19.2922 8.77734 19.6475V22.13C8.77734 23.3943 9.95165 24.3074 11.1495 23.9032C13.6097 23.073 17.4287 21.4925 19.8492 19.0719C22.2698 16.6513 23.8504 12.8324 24.6805 10.3722C25.0847 9.17429 24.1716 8 22.9074 8H20.4253Z"
                fill="white"
            />
        </svg>
    );
}
